import {VueDirective} from '@tfx/common/initializers'
import './components'

import AjaxError from './directives/ajax-error-handler'
import CopyToClipboard from './directives/copy-to-clipboard'
import LoadModal from './directives/load-modal'
import DialogRegister from './directives/dialog-register'
import Replacable from './directives/replacable'
import Ckeditor from './directives/ckeditor'
import NotifyFormErrors from './directives/notify-form-errors'
import OnlyLatinDirective from '@tfx/common/directives/only-latin-directive'

import './components/issues'

import Tooltip from './components/tooltip/tooltip-directive.js'

import './plugins/element-closest'

import {initVueResource} from './config/vue-resource'

VueDirective('tooltip', Tooltip)
VueDirective('ajax-error', AjaxError)
VueDirective('copy-to-clipboard', CopyToClipboard)
VueDirective('load-modal', LoadModal)
VueDirective('dialog-register', DialogRegister)
VueDirective('replacable', Replacable)
VueDirective('ckeditor', Ckeditor)
VueDirective('notify-form-errors', NotifyFormErrors)
VueDirective('only-latin', OnlyLatinDirective)

export function initVueJs() {
  initVueResource()
}
